import { createFileRoute } from "@tanstack/react-router";
import { AgentWorkflowPage } from "@/components/agent-cli-pages";
import { buildPageHead } from "@/lib/seo-meta";

const path = "/agent/launch-campaign";
export const Route = createFileRoute(path)({
	component: () => <AgentWorkflowPage slug="launch-campaign" />,
	head: ({ matches }) =>
		buildPageHead({
			matches,
			internalPath: path,
			title: "Run a Product Launch from Your AI Agent",
			description:
				"Build a sequenced, platform-native launch campaign and keep scheduling behind an explicit approval gate.",
		}),
});
